export default __webpack_public_path__ + "static/media/carousel-4-min.146825e4.png";